// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:20325c86-ea71-4ba0-921b-27bf67c4eb50",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_4e2RE8rbR",
    "aws_user_pools_web_client_id": "17nnd3muca985d55f24b4gidh3",
    "oauth": {}
};


export default awsmobile;
